






























































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import { SuketIstirahatInterface } from "@/types/suket_istirahat";
import SuketIstirahat from "@/services/SuketIstirahat";
import StoreSuketIstirahat from "@/store/modules/SuketIstirahat";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSKIstirahat extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketIstirahatInterface;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  today = moment().format("YYYY-MM-DD");

  register_id = this.dataSuket?.register_id || this.register;
  pasien_rm = this.dataSuket?.pasien_rm || this.statePasien.rm;
  nama = this.dataSuket?.nama || this.statePasien.nama;
  pekerjaan = this.dataSuket?.pekerjaan || this.statePasien.pekerjaan;
  alamat = this.dataSuket?.alamat || this.statePasien.alamat;
  keterangan = this.dataSuket?.keterangan || "";
  tglAwal = this.dataSuket?.tgl_mulai || this.today;
  tglAkhir = this.dataSuket?.tgl_selesai || this.today;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  dokter_id = this.dataSuket?.dokter_id || this.user.id;

  tglAwalShow = false;
  tglAkhirShow = false;

  alert = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkIstirahat = false;
  saving = false;

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      unit_id: this.unit_id,
      dokter_id: this.dokter_id,
      register_id: this.register,
      pasien_rm: this.pasien_rm,
      nama: this.nama,
      pekerjaan: this.pekerjaan,
      alamat: this.alamat,
      keterangan: this.keterangan,
      tgl_mulai: this.tglAwal,
      tgl_selesai: this.tglAkhir
    };
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtdSkIstirahat = false;
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketIstirahat.update(this.dataSuket.id, this.input)
        : SuketIstirahat.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal", 1000);

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Mata");

          this.close();
          StoreSuketIstirahat.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  inputTglAkhir() {
    this.tglAkhirShow = false;
    if (new Date(this.tglAkhir).getTime() < new Date(this.tglAwal).getTime()) {
      // alert("benar");
      this.tglAkhir = this.tglAwal;
      // this.tglAkhir = new Date().toISOString().substr(0, 10);
      appModule.sendErrorAlert(
        "Tanggal Selesai Tidak Boleh Kurang Dari Tanggal Awal"
      );
    } else {
      // if (!this.keterangan) {
      const timeDiff =
        new Date(this.tglAkhir).getTime() - new Date(this.tglAwal).getTime();
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      // alert(diffDays + " hari");
      this.keterangan = `Selama ${diffDays} Hari`;
      // }
    }
  }

  close() {
    this.$emit("close");
  }

  ttlAwalFormat() {
    return this.tglAwal
      ? moment(this.tglAwal, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  ttlAkhirFormat() {
    return this.tglAkhir
      ? moment(this.tglAkhir, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("tglAwal")
  changeTglAwal(val) {
    if (this.tglAkhir < val) {
      this.tglAkhir = val;
    }

    this.inputTglAkhir();
  }
}
